export default "__VITE_ASSET__4Yefl2WE__"